import { Pipe, PipeTransform } from '@angular/core';
import { ProductVariant } from '@greco/sales-products';

@Pipe({ name: 'variantTitle' })
export class VariantTitlePipe implements PipeTransform {
  transform(variant?: ProductVariant): string {
    return variant?.title || variant?.variantOpts?.map(opt => opt.value)?.join(', ') || variant?.id || '';
  }
}
